import Modal from '../../../Components/Modal/Modal';
import { FaSwimmer, FaFlagCheckered } from 'react-icons/fa';

import styles from './CalendarPage.module.css';

export default function CreateChoice({ data, closeCB, onSuccess }) {
    const handleChoice = (type) => {
        onSuccess({ ...data, type });
    };

    return (
        <Modal
            closeCB={closeCB}
            title={'Create Event'}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 'var(--space-lg)',
                padding: 'var(--space-md)'
            }}>
                <p style={{
                    color: 'var(--color-text-secondary)',
                    marginBottom: 'var(--space-sm)',
                    textAlign: 'center'
                }}>
                    What type of event would you like to create?
                </p>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 'var(--space-md)'
                }}>
                    <button
                        type="button"
                        className={styles.eventTypeButton}
                        onClick={() => handleChoice('workout')}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 'var(--space-sm)',
                            padding: 'var(--space-xl)',
                            border: '2px solid var(--color-border)',
                            borderRadius: 'var(--radius-lg)',
                            background: 'var(--color-surface)',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.borderColor = '#1976d2';
                            e.currentTarget.style.background = 'rgba(25, 118, 210, 0.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = 'var(--color-border)';
                            e.currentTarget.style.background = 'var(--color-surface)';
                        }}
                    >
                        <FaSwimmer size={32} style={{ color: '#1976d2' }} />
                        <span style={{ fontWeight: '600', fontSize: '1.1rem' }}>Workout</span>
                    </button>
                    <button
                        type="button"
                        className={styles.eventTypeButton}
                        onClick={() => handleChoice('race')}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 'var(--space-sm)',
                            padding: 'var(--space-xl)',
                            border: '2px solid var(--color-border)',
                            borderRadius: 'var(--radius-lg)',
                            background: 'var(--color-surface)',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.borderColor = '#1976d2';
                            e.currentTarget.style.background = 'rgba(25, 118, 210, 0.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = 'var(--color-border)';
                            e.currentTarget.style.background = 'var(--color-surface)';
                        }}
                    >
                        <FaFlagCheckered size={32} style={{ color: '#1976d2' }} />
                        <span style={{ fontWeight: '600', fontSize: '1.1rem' }}>Race</span>
                    </button>
                </div>
            </div>
        </Modal>
    );
}
